/* stylelint-disable selector-class-pattern */
/* stylelint-disable no-descending-specificity */
/* stylelint-disable font-family-no-missing-generic-family-keyword */

/* peter everywhere */

html.joke-1 *[class*='userPicture'] > *[class*='content'] {
    background-image: url('~/static/default/peter.jpg?as=jpg') !important;
    background-position: center center;
    background-size: cover;
}

html.joke-1 *[class*='userPicture'] > *[class*='content'] > div {
display:none;
}

html.joke-1 *[class*='userlink'] {
    color: var(--theme-dark-red) !important;
}

/* watch me */

html.joke-2 *[class*='card'] {
    animation: joke2 0.4s alternate infinite ease-in-out;
}

html.joke-2 *[class*='card']:nth-child(2n) {
    animation-delay: 0.2s;
}

@keyframes joke2 {
    0% {
        transform: scale(0.99);
    }

    100% {
        transform: scale(1.01);
    }
}

/* BigJulien is watching you */

html.joke-3 body::after {
    animation: joke3 6s alternate infinite ease-in-out;
    background-image: url('./assets/maxou.jpg?as=jpg');
    background-position: center center;
    background-size: cover;
    content: "";
    height: 100vh;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    width: 100%;
}

@keyframes joke3 {
    from {
        opacity: 0;
    }

    to {
        opacity: 0.2;
    }
}

/* Border */

html.joke-4 * {
    border: 1px solid #0001;
}

/* earthquake */

html.joke-5 *[class*='card'] {
    animation: joke5 1s alternate infinite ease-in-out;
}

html.joke-5 *[class*='card']:nth-child(2n) {
    animation-delay: 0.5s;
}


@keyframes joke5 {
    0% {
        transform: translateX(-1%);
    }

    100% {
        transform: translateX(1%);
    }
}

/* cursor */

html.joke-6 * {
     animation: joke6 4s alternate infinite linear;
    cursor: var(--cursor) !important;
}

@keyframes joke6 {
    0% {
        --cursor: wait;
    }

    50% {
        --cursor: progress;
    }

    100% {
        --cursor: not-allowed;
    }
}

/* Crack */

html.joke-7::before {
    background-image: url('./assets/crack.png');
    background-size: contain;
    content: '';
    display: block;
    height: 100px;
    margin: 0;
    pointer-events: none;
    position: fixed;
    right: 10vh;
    top: 10vh;
    width: 100px;
    z-index: 99;
}

/* I'm a comic */

html.joke-8 * {
    font-family: 'Comic Sans MS' !important;
}

/* flouflix */

html.joke-9 {
    filter: blur(1px);
}

/* Daltonien */

html.joke-10 body {
    animation: joke10 60s infinite;
}

@keyframes joke10 {
    from {
        filter: hue-rotate(0);
    }

    to {
        filter: hue-rotate(360deg);
    }
}

/* Samuel.css */

html.joke-11 {
    transform: scaleY(-1);
}

/* miroir miroir qui est le plus beau? */

html.joke-12 {
    transform: scaleX(-1);
}

/* à l'ancienne */

html.joke-13 {
    filter: grayscale(1);
}

/* Positive Mec :) */

html.joke-14 {
    filter: invert(1);
}

/* Sepia */

html.joke-15 {
    filter: sepia(1);
}

/* OK */

html.joke-16 * {
    font-weight: 900 !important;
    text-transform: uppercase;
}

/* Clean your screen */

html.joke-17::before {
    background-color: rgb(255 0 245);
    content: '';
    display: block;
    height: 2px;
    left: 550px;
    margin: 0;
    pointer-events: none;
    position: fixed;
    top: 352px;
    width: 2px;
    z-index: 99;
}
